// guard to check if user has an organisation
import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { map, switchMap } from "rxjs/operators";
import { OrganisationService } from "../organisation.service";
import { of } from "rxjs";

export const organisationGuard: CanActivateFn = (route, state) => {
    const organisationService = inject(OrganisationService);
    const router = inject(Router);
    const organisationSlug = route.params['organisationSlug'];
    const currentUrl = state.url;
    // Step1: check if organisationSlug is avialable in organisations
    // Step2: if not, navigate to 404 and return false
    // Step3: if yes, check if current organisation is same as organisationSlug
    // Step4: if yes, return true
    // Step5: if no, switch organisation and return false. Because Switching organisation will redirect to the correct URL and this guard will be called again.
    return organisationService.organisations$.pipe(
        switchMap(organisations => {
            
            if (organisations) {
                const targetOrg = organisations?.find(org => org.slug === organisationSlug);
                if (!targetOrg) {
                    router.navigate(['404']);
                    return [false];
                }

                return organisationService.currentOrganisation$.pipe(
                    map(currentOrg => {
                        if (currentOrg?.slug === organisationSlug) {
                            return true;
                        } else {
                            // pass the extra URL to the switchOrganisation
                            // currentUrl remove the organisationSlug from the url
                            const url = currentUrl.replace(`/${organisationSlug}`, '');
                            organisationService.switchOrganisation(targetOrg, url);
                            return false;
                        }
                }));
            } else {
                router.navigate(['/home']);
                return of(false);
            }
        })
    );



    // return organisationService.currentOrganisation$.pipe(map(organisation => {
    //     if (organisation && organisation.slug === organisationSlug) {
    //         return true;
    //     } else if (organisation && organisation.slug !== organisationSlug) {
    //         // switch organisation if organisationSlug is avialable in organisations
    //         const organisations = organisationService.organisations$;
    //         organisations.pipe(
    //             map(organisations => organisations.find(org => org.slug === organisationSlug))
    //         ).subscribe(organisation => {
    //             organisationService.switchOrganisation(organisation);
    //         });
    //     } else {
    //         router.navigate(['404']);
    //         return false;
    //     }
    // }));
}